<template>
    <div class="booking">
        <h4 class="gl-sub-title">{{ 'shopcart.client_data' | trans }}</h4>
        <ul>
            <li v-if="hasField('lastName') || hasField('name')">
                <gl-text
                    v-if="hasField('name')"
                    :required="'Required field'"
                    :placeholder="'shopcart.name' | trans"
                    v-model="name"
                />
                <gl-text
                    v-if="hasField('lastName')"
                    :required="'Required field'"
                    :placeholder="'shopcart.lastname' | trans"
                    v-model="lastName"
                />
            </li>
            <li v-if="hasField('cif')">
                <gl-text
                    :required="'Required field'"
                    :placeholder="'shopcart.cif' | trans"
                    v-model="cif"
                />
            </li>
            <li v-if="hasField('phone') || hasField('email')">
                <gl-text
                    :required="'Required field'"
                    :placeholder="'shopcart.phone' | trans"
                    v-model="phone"
                    v-if="hasField('phone')"
                />
                <gl-text
                    :required="'Required field'"
                    :placeholder="'shopcart.email' | trans"
                    v-model="email"
                    v-if="hasField('email')"
                />
            </li>
            <li v-if="hasField('address') || hasField('city')">
                <gl-text
                    :placeholder="'shopcart.address' | trans"
                    v-model="address"
                    v-if="hasField('address')"
                />
                <gl-text
                    :placeholder="'shopcart.city' | trans"
                    v-model="city"
                    v-if="hasField('city')"
                />
            </li>
            <li v-if="hasField('country') || hasField('postal')">
                <gl-text
                    :placeholder="'shopcart.country' | trans"
                    v-model="country"
                    v-if="hasField('country')"
                />
                <gl-text
                    :placeholder="'shopcart.postal' | trans"
                    v-model="postal"
                    v-if="hasField('postal')"
                />
            </li>
            <li v-if="hasField('observations')">
                <gl-textarea
                    :placeholder="'shopcart.observations' | trans"
                    v-model="observations"
                />
            </li>
        </ul>
    </div>
</template>

<script>
import { isEmpty, hasIn } from 'ramda';

import GlText from '../groovielize/components/TextInput';
import GlTextarea from '../groovielize/components/TextArea';

const fields = hasIn('fields', window.groovie) ? window.groovie.fields : [
    'name',
    'lastName',
    'phone',
    'email',
    'address',
    'city',
    'country',
    'postal',
    'observations'
];

export default {
    name: 'client-data',
    props: {
        data: {
            type: Object,
            default: () => ({
                    name: '',
                    lastName: '',
                    cif: '',
                    phone: '',
                    email: '',
                    address: '',
                    city: '',
                    country: '',
                    postal: '',
                    observations: ''
                })
        }
    },
    data() {
        return {
            name: this.data.name,
            lastName: this.data.lastName,
            cif: this.data.cif,
            phone: this.data.phone,
            email: this.data.email,
            address: this.data.address,
            city: this.data.city,
            country: this.data.country,
            postal: this.data.postal,
            observations: this.data.observations
        };
    },
    methods: {
        hasField(field) {
            let result = false;
            for (const key of fields) {
                if (key === field) {
                    result = true;
                    break;
                }
            }
            return result;
        },
        validateField(field) {
            let result = true;
            if (this.hasField(field)) {
                result = !isEmpty(this[field]);
            }

            if (result && field === 'phone') {
                result = /(^\+?[0-9]{6,})/.test(this[field]);
            }

            if (result && field === 'email') {
                result = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(this[field]);
            }
            return result;
        },
        validate() {
            let data = null;
            if (this.validateField('lastName') && this.validateField('name') &&
                this.validateField('phone') && this.validateField('email') &&
                this.validateField('cif')) {
                data = {
                    name: this.name,
                    lastName: this.lastName,
                    cif: this.cif,
                    phone: this.phone,
                    email: this.email,
                    address: this.address,
                    city: this.city,
                    country: this.country,
                    postal: this.postal,
                    observations: this.observations
                };
            }
            this.$emit('valid', data);
        }
    },
    updated() {
        this.validate();
    },
    mounted() {
        this.validate();
    },
    components: {
        GlText,
        GlTextarea
    }
};
</script>



// WEBPACK FOOTER //
// src/sections/ClientData.vue